<template>
  <div>
    <AdministrativePayrollTable ref="administrative-payroll-table-component" />
  </div>
</template>

<script>
import AdministrativePayrollTable from "@/views/rrhh/views/payroll/components/administrative-payroll/AdministrativePayrollTable.vue";

export default {
  components: {
    AdministrativePayrollTable,
  },
  methods: {
    refreshTable() {
      this.$refs["administrative-payroll-table-component"].refreshTable();
    },
  },
};
</script>

<style>
</style>